import Spacer from 'Components/common/Spacer/index';
import NavBarSection from 'Pages/AuditScreen/NavBarSection';
import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import './feConfig.scss';
import HeaderSection from './HeaderSection';
import Button from 'src/home/button-classic/button-classic';
import ACTIONS from 'src/common/action_constant';
import LoaderComponent from 'src/common/components/loader/loader';

const moduleNames = [
    {module_name: "Contracting", module_id: 1, dev_tools_enable: false},
    {module_name: "Indenting", module_id: 2, dev_tools_enable: false},
    {module_name: "VIMS", module_id: 3, dev_tools_enable: false},
    {module_name: "Accounts", module_id: 4, dev_tools_enable: false},
    {module_name: "Admin", module_id: 6, dev_tools_enable: false},
];

class FEConfigurations extends Component {
    constructor() {
        super();
        this.state = {
            data: {
                access: moduleNames
            },
            isLoader: false
        }
    }

    componentDidMount() {
        this.getDevToolConfig();
    }

    getDevToolConfig = () => {
        const { dispatch } = this.props;
        const onSuccess  = (data) => {
            this.setState({
                data: {
                    ...data,
                    access: data?.access
                }
            })
        }
        dispatch({
            type: ACTIONS.DEV_TOOL_CONFIG.GET_DEV_TOOL_CONFIG,
            onSuccess
        })
    }

    handleOnClickBackBtn = () => {
        const { history } = this.props;
        history.goBack();
    }

    onSave = () => {
        const { dispatch, history } = this.props;
        const { data } = this.state;
        const onSuccess = () => {
            this.getDevToolConfig();
            this.setLoader();
        }
        const onError = () => {
            this.setLoader();
        }
        this.setLoader();
        dispatch({
            type: ACTIONS.DEV_TOOL_CONFIG.POST_DEV_TOOL_CONFIG,
            payload: {
                ...data
            },
            onSuccess,
            onError
        })
    }

    setLoader = () => {
        this.setState((prevState) => ({
            isLoader: !prevState.isLoader
        }))
    }

    onClickAll = (e) => {
        const { checked } = e.target;
        this.setState((prevState) => ({
            data: {
                access: prevState.data.access.map((module) => ({
                    ...module,
                    dev_tools_enable: checked
                }))
            }
        }));
    };

    checkAllSelected = () => {
        const { access } = this.state.data;
        return (access || []).every(el => el.dev_tools_enable);
    }

    onChangeSelection = (e, index) => {
        const { checked } = e.target;
        this.setState((prevState) => {
            const updatedList = [...prevState.data.access]
            updatedList[index] = {
                ...updatedList[index],
                dev_tools_enable: checked
            }
            return {
                data: {
                    ...prevState.data,
                    access: updatedList,
                }
            };
        })
    }

    render() {
        const { access } = this.state.data;
        return (
          <Fragment>
            {this.state.isLoader && <LoaderComponent />}
            <NavBarSection />
            <Spacer spacing={"40px"} />
            <div className="feConfigpageWrapper">
               <HeaderSection handleOnClickBackBtn={this.handleOnClickBackBtn} />
                <div className="flex items-center justify-between">
                    <div className="table-container">
                        <table className="feCongigTable">
                            <thead>
                            <tr>
                                <th>Sl No.</th>
                                <th>Module</th>
                                <th><div><input type="checkbox" onChange={this.onClickAll} checked={this.checkAllSelected()}/> Dev Tools</div></th>
                            </tr>
                            </thead>
                            <tbody>
                                {(access || []).map((module, index) => {
                                    return(
                                        <tr key={module.module_id}>   
                                            <td>{index + 1}</td>
                                            <td>
                                            {module.module_name}
                                            </td>
                                            <td><input type={'checkbox'} checked={module.dev_tools_enable} onChange={(e) => this.onChangeSelection(e, index)}/></td>
                                        </tr>
                                    )})}  
                            </tbody>
                        </table>
                    </div>
                </div>
                <Spacer spacing={"20px"} />
                <div className="flex justify-center ht-30">
                    <Button
                        value={"Save"}
                        click={this.onSave}
                    />
                </div>
            </div>
          </Fragment>
        );
      }
}

export default connect()(withRouter(FEConfigurations));

